<div class="media">
  <img class="rounded-circle avatar-img" [src]="imageUrl" />
  <div class="media-body">
    <h6 class="mb-0" [innerHtml]="header"></h6>
    <p class="font-weight-light fs-15" [innerHtml]="subHeader"></p>
  </div>
</div>
